export default __webpack_public_path__ + "static/media/budget.fac5ee7a.svg";